import { objectValues } from "./functions.js"

export const OPERATIONAL_STATUSES_DESCRIPTION = {
    OPERATIONAL: 'Fully functional and available',
    IN_MAINTENANCE: 'Temporarily unavailable for maintenance',
    UNDER_CONSTRUCTION: 'Currently under construction or renovation',
    CLOSED: 'Permanently or indefinitely closed'
};
export const OPERATIONAL_STATUSES_ENUM = objectValues(OPERATIONAL_STATUSES_DESCRIPTION);

export const AVAILABILITY_STATUSES_DESCRIPTION = {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied',
    RESERVED: 'reserved',
    IN_MAINTENANCE: 'in_maintenance',
    BLOCKED: 'blocked',
};
export const AVAILABILITY_STATUSES_ENUM = objectValues(AVAILABILITY_STATUSES_DESCRIPTION);

export const ASSIGNMENT_STATUSES_DESCRIPTION = {
    PERMANENT: 'permanent',
    FLEXIBLE: 'flexible',
    HOT_DESK: 'hot_desk',
    TEMPORARY: 'temporary',
    DEFAULT: 'default'
};
export const ASSIGNMENT_STATUSES_ENUM = objectValues(ASSIGNMENT_STATUSES_DESCRIPTION);


export const LEVELS_DESCRIPTION = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
};
export const LEVELS_ENUM = objectValues(LEVELS_DESCRIPTION);

export const VENTILATION_OPTIONS_DESCRIPTION = {
    NATURAL: 'natural',
    AC: 'ac',
    BOTH: 'both'
};
export const VENTILATION_OPTIONS_ENUM = objectValues(VENTILATION_OPTIONS_DESCRIPTION);

export const ACCOMMODATION_TYPES_DESCRIPTION = {
    EXECUTIVE: 'executive',
    SOFA: 'sofa',
    COMMON: 'common',
    ERGONOMIC: 'ergonomic'
};
export const ACCOMMODATION_TYPES_ENUM = objectValues(ACCOMMODATION_TYPES_DESCRIPTION);

export const DESK_TYPES_DESCRIPTION = {
    FIXED: 'fixed',
    ADJUSTABLE: 'adjustable',
    STANDING: 'standing'
};
export const DESK_TYPES_ENUM = objectValues(DESK_TYPES_DESCRIPTION);

export const SECURITY_TYPES_DESCRIPTION = {
    FINGERPRINT: 'fingerprint',
    FACE_DETECTION: 'face_detection',
    SHARED_FINGERPRINT: 'shared_fingerprint'
};
export const SECURITY_TYPES_ENUM = objectValues(SECURITY_TYPES_DESCRIPTION);

export const VERIFICATION_TYPES_DESCRIPTION = {
    APPROVED: 'when the item is active',
    PENDING: 'when the item is pending',
    REJECTED: 'when the item is rejected',
    NOTIFIED: 'when the item is notified',
    CANCELLED: 'when the item is cancelled',
    COMPLETED: 'when the item is completed'
};
export const VERIFICATION_TYPES_ENUM = objectValues(VERIFICATION_TYPES_DESCRIPTION);

export const BUSINESS_LEADS_DESCRIPTION = {
    NEW: 'new',
    CONTACTED: 'contacted',
    QUALIFIED: 'qualified',
    NEGOTIATING: 'negotiating',
    FOLLOW_UP: 'follow_up',
    REJECTED: 'rejected',
    COMPLETED: 'completed'
};
export const BUSINESS_LEADS_ENUM = objectValues(BUSINESS_LEADS_DESCRIPTION);

export const EMAIL_SUBSCRIPTIONS_DESCRIPTION = { // data usage permissions for sending emails
    MARKETING: 'marketing',
    SALES: 'sales',
    PRODUCT_UPDATES: 'product_updates',
    ANALYTICS: 'analytics',
    THIRD_PARTY_SHARING: 'third_party_sharing'
}
export const EMAIL_SUBSCRIPTIONS_ENUM = objectValues(EMAIL_SUBSCRIPTIONS_DESCRIPTION);

export const MARKETING_CHANNELS_DESCRIPTION = {
    WEBSITE: 'website',
    GOOGLE: 'google',
    LINKEDIN: 'linkedin',
    WALK_IN: 'walk_in',
    REFERRAL: 'referral',
    COLD_CALL: 'cold_call',
    TRADE_SHOW: 'trade_show',
    WEBINAR: 'webinar',
    SOCIAL_MEDIA: 'social_media',
    EMAIL_CAMPAIGN: 'email_campaign',
    PHONE: 'phone',
    ADVERTISEMENT: 'advertisement',
    OTHER: 'other'
};
export const MARKETING_CHANNELS_ENUM = objectValues(MARKETING_CHANNELS_DESCRIPTION);

export const DEAL_STAGES_DESCRIPTION = {
    NEW: 'new',
    CONTACTED: 'contacted',
    QUALIFIED: 'qualified',
    NEGOTIATING: 'negotiating',
    WON: 'won',
    OPEN: 'open',
    DO_NOT_CONTACT: 'do_not_contact',
};
export const DEAL_STAGES_ENUM = objectValues(DEAL_STAGES_DESCRIPTION);

// ['email', 'phone', 'in_person', 'video_call', 'social_media', 'other']
export const CONTACT_TYPES_DESCRIPTION = {
    EMAIL: 'email',
    PHONE: 'phone',
    IN_PERSON: 'in_person',
    VIDEO_CALL: 'video_call',
    SOCIAL_MEDIA: 'social_media',
    OTHER: 'other'
};
export const CONTACT_TYPES_ENUM = objectValues(CONTACT_TYPES_DESCRIPTION);

// ['strong', 'moderate', 'weak']
export const RELATIONSHIP_STRENGTHS_DESCRIPTION = {
    STRONG: 'strong',
    MODERATE: 'moderate',
    WEAK: 'weak'
};
export const RELATIONSHIP_STRENGTHS_ENUM = objectValues(RELATIONSHIP_STRENGTHS_DESCRIPTION);

// ['not_sent', 'sent', 'reviewing', 'accepted', 'rejected']
export const BUSINESS_LEAD_STATUS_DESCRIPTION = {
    NOT_SENT: 'not_sent',
    SENT: 'sent',
    REVIEWING: 'reviewing',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected'
};
export const BUSINESS_LEAD_STATUS_ENUM = objectValues(BUSINESS_LEAD_STATUS_DESCRIPTION);

// ['not_started', 'early_discussion', 'proposal_review', 'final_terms', 'contract_signed']
export const NEGOTIATION_STAGES_DESCRIPTION = {
    NOT_STARTED: 'not_started',
    EARLY_DISCUSSION: 'early_discussion',
    PROPOSAL_REVIEW: 'proposal_review',
    FINAL_TERMS: 'final_terms',
    CONTRACT_SIGNED: 'contract_signed'
};
export const NEGOTIATION_STAGES_ENUM = objectValues(NEGOTIATION_STAGES_DESCRIPTION);

//['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-5000', '5001+']
export const COMPANY_SIZES_DESCRIPTION = {
    MICRO: '1-10',
    SMALL: '11-50',
    MEDIUM: '51-200',
    LARGE: '201-500',
    XLARGE: '501-1000',
    XXLARGE: '1001-5000',
    XXXLARGE: '5001+'
};
export const COMPANY_SIZES_ENUM = objectValues(COMPANY_SIZES_DESCRIPTION);

export const ANNUAL_REVENUES_DESCRIPTION = {
    LESS_THAN_10M: 'PKR:10000000:<10M', // 10M
    FROM_10M_TO_100M: 'PKR:100000000:10M-100M', // 100M
    FROM_100M_TO_500M: 'PKR:500000000:100M-500M', // 500M
    FROM_500M_TO_1B: 'PKR:1000000000:500M-1B', // 1B
    FROM_1B_TO_5B: 'PKR:5000000000:1B-5B', // 5B
    FROM_5B_TO_10B: 'PKR:10000000000:5B-10B', // 10B
    GREATER_THAN_10B: 'PKR:X:10B+' // 50B
};
export const ANNUAL_REVENUES_ENUM = objectValues(ANNUAL_REVENUES_DESCRIPTION);

export const DEAL_SIZES_DESCRIPTION = {
    LESS_THAN_100K: 'PKR:100000:<100K', // less than 100K
    FROM_100K_TO_500K: 'PKR:500000:100K-500K', // 100K - 500K
    FROM_500K_TO_1M: 'PKR:1000000:500K-1M', // 500K - 1M
    FROM_1M_TO_5M: 'PKR:5000000:1M-5M', // 1M - 5M
    FROM_5M_TO_10M: 'PKR:10000000:5M-10M', // 5M - 10M
    FROM_10M_TO_50M: 'PKR:50000000:10M-50M', // 10M - 50M
    FROM_50M_TO_100M: 'PKR:100000000:50M-100M', // 50M - 100M
    FROM_100M_TO_500M: 'PKR:500000000:100M-500M', // 50M - 100M
    FROM_500M_TO_1B: 'PKR:1000000000:500M-1B', // 500M - 1B
    GREATER_THAN_1B: 'PKR:X:1B+', // 100M
};
export const DEAL_SIZES_ENUM = objectValues(DEAL_SIZES_DESCRIPTION);

// ['immediate', '1-3 months', '3-6 months', '6-12 months', '12+ months']
export const SALES_CYCLE_LENGTHS_DESCRIPTION = {
    IMMEDIATE: 'immediate',
    FROM_1_TO_3_DAYS: '1-3 Days',
    FROM_3_TO_6_DAYS: '3-7 Days',
    FROM_6_TO_12_DAYS: '7-15 Days',
    MORE_THAN_12_DAYS: '15+ Days',
};
export const SALES_CYCLE_LENGTHS_ENUM = objectValues(SALES_CYCLE_LENGTHS_DESCRIPTION);

export const STATIC_USER_ROLES_DESCRIPTION = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    EMPLOYEE: 'employee',
    GUEST: 'guest',
    // SUPER_ADMIN: 'super_admin',
    USER: 'user',
    TEAM_MEMBER: 'team_member'
};
export const STATIC_USER_ROLES_ENUM = objectValues(STATIC_USER_ROLES_DESCRIPTION);

export const CONNECTION_TYPES_DESCRIPTION = {
    PERMANENT: 'permanent',
    TEMPORARY: 'temporary',
    DAY_PASS: 'day_pass'
};
export const CONNECTION_TYPES_ENUM = objectValues(CONNECTION_TYPES_DESCRIPTION);

export const DAY_PASS_TYPES_DESCRIPTION = {
    NONE: 'General access with no specific rules',
    SINGLE: 'Valid for one-time use on a single day',
    RANDOM: 'Use on any day - no schedule needed',
    DISCREET: 'Balanced access with equal entry and exit',
    MEETING_ROOM_ONLY: 'Access limited to meeting room facilities only',
};
export const DAY_PASS_TYPES_ENUM = objectValues(DAY_PASS_TYPES_DESCRIPTION);

export const PRICE_TYPES_DESCRIPTION = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
};
export const PRICE_TYPES_ENUM = objectValues(PRICE_TYPES_DESCRIPTION);

export const DAYS_OF_WEEK_DESCRIPTION = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday'
};
export const DAYS_OF_WEEK_ENUM = objectValues(DAYS_OF_WEEK_DESCRIPTION);

// Category descriptions now live on each SupportCategory record and are edited in
// Settings → Support, so there's nothing to hardcode here.

export const SUPPORT_TICKET_STATUSES_DESCRIPTION = {
    OPEN: 'open',
    IN_PROGRESS: 'in_progress',
    PENDING_CUSTOMER: 'pending_customer',
    RESOLVED: 'resolved',
    CLOSED: 'closed',
    CANCELLED: 'cancelled'
};
export const SUPPORT_TICKET_STATUSES_ENUM = objectValues(SUPPORT_TICKET_STATUSES_DESCRIPTION);

export const SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES_DESCRIPTION = {
    PENDING: 'pending',
    ACKNOWLEDGED: 'acknowledged',
    DISPUTED: 'disputed'
};
export const SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES_ENUM = objectValues(SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES_DESCRIPTION);

export const SUPPORT_TICKET_NOTIFICATION_TYPES_DESCRIPTION = {
    TICKET_CREATED: 'ticket_created',
    STATUS_UPDATED: 'status_updated',
    AGENT_ASSIGNED: 'agent_assigned',
    NEW_MESSAGE: 'new_message',
    RESOLVED_PENDING_ACK: 'resolved_pending_ack',
    AUTO_CLOSE_WARNING: 'auto_close_warning',
    TICKET_CLOSED: 'ticket_closed',
    ESCALATION_ALERT: 'escalation_alert',
    SLA_BREACH_WARNING: 'sla_breach_warning'
}
export const SUPPORT_TICKET_NOTIFICATION_TYPES_ENUM = objectValues(SUPPORT_TICKET_NOTIFICATION_TYPES_DESCRIPTION);

export const NOTIFICATION_DELIVERY_METHODS_DESCRIPTION = {
    IN_APP: 'in_app',
    EMAIL: 'email',
    BROWSER_NOTIFICATION: 'browser_notification'
}
export const NOTIFICATION_DELIVERY_METHODS_ENUM = objectValues(NOTIFICATION_DELIVERY_METHODS_DESCRIPTION);

export const NOTIFICATION_STATUSES_DESCRIPTION = {
    PENDING: 'pending',
    SENT: 'sent',
    FAILED: 'failed',
    READ: 'read',
    SEEN: 'seen'
}
export const NOTIFICATION_STATUSES_ENUM = objectValues(NOTIFICATION_STATUSES_DESCRIPTION);

export const NOTIFICATION_PRIORITY_DESCRIPTION = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent'
}
export const NOTIFICATION_PRIORITY_ENUM = objectValues(NOTIFICATION_PRIORITY_DESCRIPTION);

export const SUPPORT_TICKET_INTERACTION_TYPES_DESCRIPTION = {
    NOTE: 'note',
    EMAIL: 'email',
    PHONE: 'phone',
    CHAT: 'chat',
    INTERNAL_NOTE: 'internal_note',
    STATUS_CHANGE: 'status_change',
    ASSIGNMENT: 'assignment'
}
export const SUPPORT_TICKET_INTERACTION_TYPES_ENUM = objectValues(SUPPORT_TICKET_INTERACTION_TYPES_DESCRIPTION);

export const SUPPORT_TICKET_INTERACTION_VISIBILITY_DESCRIPTION = {
    CUSTOMER: 'customer',
    AGENT: 'agent',
    INTERNAL: 'internal'
}
export const SUPPORT_TICKET_INTERACTION_VISIBILITY_ENUM = objectValues(SUPPORT_TICKET_INTERACTION_VISIBILITY_DESCRIPTION);


export const COLORS_DESCRIPTION = {
    primary: "#ffa726",
    secondary: "#000000",
    success: "#8bc34a",
    error: "#f44336", // red
    info: "#2196f3",
    warning: "#ffc107",
    light: "#f5f5f5",
    dark: "#212121",
    muted: "#6c757d",
}

export const DAY_PASSES_TYPES_DESCRIPTION = {
    HOURLY: 'Hourly Pass',
    DAILY: 'Daily Pass',
    MONTHLY_RECURRING: 'Monthly Recurring Pass'
};
export const DAY_PASSES_TYPES_ENUM = objectValues(DAY_PASSES_TYPES_DESCRIPTION);

export const PAYMENT_STATUS_DESCRIPTION = {
    PENDING: 'When the payment is pending',
    PAID: 'When the payment is paid',
    FAILED: 'When the payment failed',
    REFUNDED: 'If the payment is refunded'
};
export const PAYMENT_STATUS_ENUM = objectValues(PAYMENT_STATUS_DESCRIPTION);

export const PAYMENT_METHODS_DESCRIPTION = {
    CASH: 'Payment in cash',
    CARD: 'Payment by card',
    BANK_TRANSFER: 'Amount transferred to bank account',
    ONLINE: 'Payment through online means'
};
export const PAYMENT_METHODS_ENUM = objectValues(PAYMENT_METHODS_DESCRIPTION);